<template>
  <div class="d-flex flex-column align-center justify-center pa-6 pa-md-0">
    <v-select
      v-model="year"
      class="mr-6 align-self-start"
      :items="['2020', '2021', '2022', '2023', '2024', '2025', '2026']"
      @change="getPeriods"
      label="Έτος"
    ></v-select>

    <v-simple-table class="table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-sm-body-1 font-weight-bold">Όνομα</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <!-- <th class="text-sm-body-1 font-weight-bold">Κατάσταση</th> -->
            <th></th>
            <th></th>
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in periods" :key="item.reportPeriodId + i">
            <td class="text-sm-body-1">
              {{ item.reportPeriodName }}
            </td>

            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <!-- <v-switch
                v-model="switches[i]"
                @change="onChange(item.itemKey, switches[i])"
              ></v-switch> -->
            </td>
            <td></td>

            <td></td>

            <!-- <td>
              <v-btn class="mr-2" color="primary" fab x-small>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td> -->
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn
      class="
        success
        rounded
        text-sm-body-1
        font-weight-regular
        align-self-end
        mb-8
        mt-8
      "
      @click="dialog = true"
    >
      <v-icon>mdi-plus</v-icon>
      <span>Προσθήκη</span>
    </v-btn>

    <v-dialog max-width="500px" v-model="dialog">
      <AddSubmissionPeriod
        @getPeriods="getPeriods"
        :year="year"
        @closeDialog="dialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import AddSubmissionPeriod from "../../components/Modals/Period/AddSubmissionPeriod.vue";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {
    AddSubmissionPeriod,
  },
  async created() {
    try {
      this.year = new Date().getFullYear().toString();
      await this.getPeriods();
      this.sortPeriods();
      this.switches = this.periods.map((el) => el.status);
    } catch {}
  },
  data() {
    return {
      year: "2022",
      switches: [],
      periods: [],
      dialog: false,
    };
  },

  computed: {
    ...mapState({}),
  },

  methods: {
    ...mapMutations(["sortPeriods"]),
    ...mapActions(["deletePeriod", "changePeriodStatus"]),

    async getPeriods() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/System/GetPeriodsbyYear/${this.year}`
        );
        this.periods = res.data;
      } catch (e) {
        console.log(e);
      }
    },

    async onChange(id, value) {
      try {
        this.changePeriodStatus({
          reportPeriodId: id,
          isOpenForSubmission: value,
        });
      } catch {}
    },
  },
};
</script>

<style scoped lang="scss">
.table {
  width: 800px;
}

@media only screen and (max-width: 960px) {
  .table {
    width: 600px;
  }
}

@media only screen and (max-width: 600px) {
  .table {
    width: 350px;
  }
}
</style>
